import React from "react";
import {ArrowPathIcon, CheckCircleIcon, CheckIcon, StopIcon, XMarkIcon} from "@heroicons/react/20/solid";
import Tooltip from "../../../common/components/tooltip";

export default function BulkActionBar({selectedItems, onSelectAll, onDeselectAll, onToggleInvert, onClear}) {
    if (!selectedItems.length) return null;

    const count = selectedItems.length;
    const countLabel = count === 1 ? "1 category selected" : `${count} categories selected`;

    return (
        <div
            role="region"
            aria-label="Bulk actions for selected categories"
            className="flex flex-wrap items-center gap-3 bg-inverse rounded-[12px] border border-tm-gray-200 px-4 py-[14px] ring-4 ring-primary/20 left-1/2 fixed z-50 bottom-2 animate-fade-in-bottom"
        >
            <Tooltip
                content={
                    <div className="text-left">
                        {selectedItems.map(i => (
                            <div key={i.categoryName + i.subCategoryName}>{i.subCategoryName}</div>
                        ))}
                    </div>
                }
                placement="top"
            >
                <div
                    aria-live="polite"
                    className="order-1 flex items-center gap-1.5 bg-primary/10 text-primary rounded-full px-3 py-1 text-[13px] font-medium shrink-0 cursor-default"
                >
                    <CheckCircleIcon className="size-[14px] shrink-0"/>
                    {countLabel}
                </div>
            </Tooltip>

            <div className="order-3 sm:order-2 basis-full sm:basis-auto flex items-center flex-wrap gap-2 flex-1">
                <button
                    className="inline-flex items-center gap-1.5 rounded-btn text-[13px] font-semibold px-3 py-1.5 bg-primary text-primary-contrast hover:bg-primary-shade cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
                    onClick={onSelectAll}
                >
                    <CheckIcon className="size-[14px] shrink-0"/>
                    Select all permissions
                </button>

                <button
                    className="inline-flex items-center gap-1.5 rounded-btn text-[13px] font-semibold px-3 py-1.5 border border-tm-gray-300 text-tm-gray-700 bg-transparent hover:border-tm-gray-700 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
                    onClick={onDeselectAll}
                >
                    <StopIcon className="size-[14px] shrink-0"/>
                    Deselect all permissions
                </button>

                <button
                    className="inline-flex items-center gap-1.5 rounded-btn text-[13px] font-semibold px-3 py-1.5 border border-tm-gray-300 text-tm-gray-700 bg-transparent hover:border-tm-gray-700 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
                    onClick={onToggleInvert}
                >
                    <ArrowPathIcon className="size-[14px] shrink-0"/>
                    Toggle (invert)
                </button>
            </div>

            <button
                className="order-2 sm:order-3 ml-auto sm:ml-0 inline-flex items-center gap-1.5 rounded-btn text-[12px] font-semibold px-3 py-1.5 border border-tm-gray-300 text-tm-gray-700 bg-transparent hover:border-tm-gray-700 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-primary shrink-0"
                onClick={onClear}
            >
                <XMarkIcon className="size-[14px] shrink-0"/>
                Clear
            </button>
        </div>
    );
}
